const translations = {
    alert: 'Incident'
};

export default translations;
